import { motion } from "framer-motion";

const MANIFESTO = [
  { num: "01", title: "100% सत्यता एवं निष्पक्षता", desc: "बिना किसी राजनीतिक अथवा कॉर्पोरेट दबाव के निष्पक्ष समाचार प्रस्तुत करना हमारा पहला धर्म है।" },
  { num: "02", title: "त्वरित एवं सटीक कवरेज", desc: "घटनास्थल से सबसे पहले, पर पूरी जांच और सत्यापन के साथ सटीक जानकारी आप तक पहुंचाना।" },
  { num: "03", title: "जन-सरोकार की आवाज़", desc: "आम नागरिक के अधिकारों, समस्याओं और उपलब्धियों को मुख्यधारा में प्राथमिकता देना।" },
  { num: "04", title: "पारदर्शी डिजिटल मीडिया", desc: "बिना भ्रामक क्लिकबैट के गुणवत्तापूर्ण, शोध-आधारित और विचारोत्तेजक पत्रकारिता।" },
];

export const EditorialMarquee = () => {
  const words = ["खबरिक", "सच की सीधी आवाज़", "निष्पक्ष", "निर्भीक", "त्वरित"];
  const row = [...words, ...words, ...words, ...words];
  return (
    <div className="overflow-hidden border-y border-white/10 py-6 my-16 bg-[#101014]" data-testid="editorial-marquee">
      <div className="flex whitespace-nowrap animate-marquee-slow">
        {row.map((w, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className={`font-display text-4xl sm:text-5xl ${i % 2 === 0 ? "text-[#FFD400]" : "text-slate-500"}`}>
              {w}
            </span>
            <span className="w-2.5 h-2.5 rounded-full bg-[#FFD400]/40" />
          </span>
        ))}
      </div>
    </div>
  );
};

export const Manifesto = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 py-12" data-testid="manifesto-section">
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
      className="mb-12"
    >
      <span className="font-mono-meta text-xs text-[#FFD400] uppercase tracking-[0.3em]">हमारे सिद्धांत</span>
      <h2 className="font-display text-3xl sm:text-4xl text-white mt-3">खबरिक पत्रकारिता सिद्धांत</h2>
    </motion.div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
      {MANIFESTO.map((m, i) => (
        <motion.div
          key={m.num}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: i * 0.12 }}
          className="bg-[#0D0D10] p-8 group hover:bg-[#15151A] transition-colors duration-300"
        >
          <span className="font-display text-5xl text-stroke-yellow group-hover:text-[#FFD400] group-hover:[-webkit-text-stroke:0px] transition-all block">
            {m.num}
          </span>
          <h3 className="font-editorial font-bold text-white text-lg mt-6 leading-snug">{m.title}</h3>
          <p className="text-sm text-slate-400 mt-3 leading-relaxed">{m.desc}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
